<app-universal-modal-template
  [state]="state()"
  [error]="error()"
  [showCloseButton]="true"
  [isSubmitting]="isSubmitting()"
  [isSubmitted]="isSubmitted()"
  [submittingText]="submittingText()"
  [submittedText]="submittedText()"
  [formInstance]="formInstance()"
  [groups]="groups()"
  [isFormValid]="!formInvalid()"
  (closeEvent)="onAction({ id: 'close' })"
  (retryEvent)="onAction({ id: 'retry' })"
  (componentAction)="onAction($event)"
/>
